import { motion } from "framer-motion";
import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import QuoteDialog from "@/components/QuoteDialog";
import { easeExpo } from "@/lib/motion";

export default function CTASection() {
  const [open, setOpen] = useState(false);
  return (
    <section
      id="contact"
      className="relative py-32 md:py-44"
      data-testid="section-cta"
    >
      {/* Aurora */}
      <div
        className="aurora animate-aurora"
        style={{
          width: 720,
          height: 720,
          left: "50%",
          top: "50%",
          transform: "translate(-50%,-50%)",
          background:
            "radial-gradient(circle, rgba(0,229,255,0.28) 0%, rgba(0,229,255,0) 60%)",
        }}
      />

      <div className="mx-auto max-w-[1200px] px-6 md:px-12 relative">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: easeExpo }}
          className="glass-strong relative rounded-3xl p-8 md:p-14 lg:p-20 overflow-hidden"
        >
          {/* Grid backdrop */}
          <div className="absolute inset-0 bg-grid-fine opacity-40 pointer-events-none" />
          {/* Corner brackets */}
          <Bracket className="top-4 left-4" />
          <Bracket className="top-4 right-4 rotate-90" />
          <Bracket className="bottom-4 left-4 -rotate-90" />
          <Bracket className="bottom-4 right-4 rotate-180" />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-8">
              <div className="text-[11px] font-mono tracking-[0.22em] uppercase text-electric-500 mb-6">
                06 / Sourcing desk
              </div>
              <h2 className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[0.98] text-white">
                Need hard-to-find <br />
                <span className="gradient-text">components?</span>
              </h2>
              <p className="mt-6 text-slate-300 text-lg leading-relaxed max-w-[560px]">
                Get a quote in under 24 hours. Share your BOM, part number or
                the problem you&apos;re trying to solve — we&apos;ll take it from there.
              </p>
            </div>

            <div className="lg:col-span-4 flex flex-col gap-4 lg:items-end">
              <button
                data-testid="cta-request-quote-button"
                onClick={() => setOpen(true)}
                className="btn-electric rounded-full px-6 py-3.5 text-sm font-medium inline-flex items-center gap-2 self-start lg:self-auto"
              >
                Request Quote <ArrowUpRight className="w-4 h-4" />
              </button>
              <a
                href="mailto:desk@omnicoretek.com"
                data-testid="cta-email-link"
                className="text-sm text-slate-300 hover:text-white electric-underline self-start lg:self-auto"
              >
                desk@omnicoretek.com
              </a>
              <p className="text-[11px] font-mono tracking-[0.22em] uppercase text-slate-500 mt-2 self-start lg:self-auto">
                24h SLA · 15+ countries
              </p>
            </div>
          </div>
        </motion.div>
      </div>
      <QuoteDialog open={open} onOpenChange={setOpen} />
    </section>
  );
}

function Bracket({ className = "" }) {
  return (
    <div
      className={`absolute w-8 h-8 border-t border-l border-electric-500/50 ${className}`}
      style={{ transformOrigin: "center" }}
      aria-hidden
    />
  );
}
